import {IndividualContactSiteHistoryApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import * as moment from "moment";
import {none, Option} from "ts-option";
import Address from "../address/Address";

export default class AddressHistory {
	/**
	 * @param {string} siteId site identifier for address history
	 * @param {moment.Duration} residencePeriod period of how long a person lived under given address.
	 * @param {boolean} isCurrent is address current address of a person.
	 * @param {Option<Address>} address optional address linked with site.
	 */
	constructor(public readonly siteId: string,
		public readonly residencePeriod: moment.Duration,
		public readonly isCurrent: boolean,
		public readonly address: Option<Address>) {}

	toJson(): IndividualContactSiteHistoryApiDto {
		const json: IndividualContactSiteHistoryApiDto = {
			current: this.isCurrent,
			livingTime: this.residencePeriod.toISOString(),
			siteId: this.siteId
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({siteId = this.siteId, residencePeriod = this.residencePeriod, isCurrent = this.isCurrent, address = this.address}) {
		return new AddressHistory(siteId, residencePeriod, isCurrent, address);
	}

	static fromJson(json: IndividualContactSiteHistoryApiDto) {
		return new AddressHistory(json.siteId, moment.duration(json.livingTime), json.current, none);
	}
}